"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _contentGroup = babelHelpers.interopRequireDefault(require("./contentGroup"));

var _decorators = require("decorators");

var PersonContentBlock =
/*#__PURE__*/
function (_ContentGroupBlock) {
  babelHelpers.inherits(PersonContentBlock, _ContentGroupBlock);

  function PersonContentBlock() {
    babelHelpers.classCallCheck(this, PersonContentBlock);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PersonContentBlock).apply(this, arguments));
  }

  return PersonContentBlock;
}(_contentGroup.default);

exports.default = PersonContentBlock;